import React from 'react';
import { Button } from './button';
import classNames from 'classnames';

/**
* @param {Object} props
* @param {Object} props.children
* @param {string} props.className
* @param {boolean} props.disabled
* @param {string} props.id
* @param {boolean} props.isLoading
* @param {Function} props.onClick
* @param {string} props.size - "sm", "md", "lg"
* @param {string} props.type
* @returns {Object}
*/
export function ButtonPrimary(props) {
	const { children, className, disabled, id, isLoading, onClick, size, type, } = props;
	const buttonClassName = classNames(
		"primary",
		className,
	);
	return (
		<Button
			className={buttonClassName}
			disabled={disabled}
			id={id}
			isLoading={isLoading}
			onClick={onClick}
			size={size}
			type={type}
		>	
			{children}
		</Button>

	);
};
